


import { useState } from 'react';
import { FaTrash, FaPlus, FaChevronDown, FaChevronUp } from 'react-icons/fa';

export default function EmploymentSection({ employmentList, setEmploymentList }) {
//   const [employmentList, setEmploymentList] = useState([
//     {
//       id: Date.now(),
//       company: '',
//       position: '',
//       duration: '',
//       responsibilities: '',
//       reason: '',
//     },
//   ]);

//   const [expandedId, setExpandedId] = useState(employmentList[0].id);

const [expandedId, setExpandedId] = useState(
    employmentList.length ? employmentList[0].id : null
  );

  const handleChange = (index, field, value) => {
    const updated = [...employmentList];
    updated[index][field] = value;
    setEmploymentList(updated);
  };

  const addNewEntry = () => {
    const newEntry = {
      id: Date.now(),
      company: '',
      position: '',
      duration: '',
      responsibilities: '',
      reason: '',
    };
    setEmploymentList([...employmentList, newEntry]);
    setExpandedId(newEntry.id);
  };

  const removeEntry = (index) => {
    const updated = [...employmentList];
    const removed = updated.splice(index, 1);
    setEmploymentList(updated);

    if (expandedId === removed[0].id && updated.length > 0) {
      setExpandedId(updated[0].id);
    }
  };

  const toggleExpand = (id) => {
    setExpandedId(id === expandedId ? null : id);
  };

  return (
    <div className="space-y-6">
      {employmentList.map((item, index) => {
        const isExpanded = item.id === expandedId;
        return (
          <div
            key={item.id}
            className="border rounded-xl shadow-sm bg-gray-50 relative"
          >
            {/* Header / Summary View */}
            <div
              className={`flex justify-between items-center p-4 cursor-pointer ${
                isExpanded ? 'border-b' : ''
              }`}
              onClick={() => toggleExpand(item.id)}
            >
              <div className="font-medium text-gray-800">
                {item.company || `Employment ${index + 1}`}
              </div>
              <div className="flex items-center gap-3">
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    removeEntry(index);
                  }}
                  className="text-red-500 hover:text-red-700"
                >
                  <FaTrash />
                </button>
                <span className="text-gray-400">
                  {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
                </span>
              </div>
            </div>

            {/* Expanded Form */}
            {isExpanded && (
              <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                <input
                  type="text"
                  placeholder="Previous Employer"
                  className="rounded-full border px-4 py-2 w-full"
                  value={item.company}
                  onChange={(e) =>
                    handleChange(index, 'company', e.target.value)
                  }
                />
                <input
                  type="text"
                  placeholder="Position Held"
                  className="rounded-full border px-4 py-2 w-full"
                  value={item.position}
                  onChange={(e) =>
                    handleChange(index, 'position', e.target.value)
                  }
                />
                <input
                  type="text"
                  placeholder="Duration of Employment"
                  className="rounded-full border px-4 py-2 w-full"
                  value={item.duration}
                  onChange={(e) =>
                    handleChange(index, 'duration', e.target.value)
                  }
                />
                <textarea
                  placeholder="Job Responsibilities"
                  className="rounded-xl border px-4 py-2 w-full"
                  value={item.responsibilities}
                  onChange={(e) =>
                    handleChange(index, 'responsibilities', e.target.value)
                  }
                />
                <textarea
                  placeholder="Reason for Leaving"
                  className="rounded-xl border px-4 py-2 w-full"
                  value={item.reason}
                  onChange={(e) =>
                    handleChange(index, 'reason', e.target.value)
                  }
                />
              </div>
            )}
          </div>
        );
      })}

      {/* Add New Button */}
      <button
        type="button"
        className="mt-4 flex items-center gap-2 text-primary font-semibold"
        onClick={addNewEntry}
      >
        <FaPlus /> Add Employment History
      </button>
    </div>
  );
}
